import { Box, Divider, Link } from "@mui/material";
import { hr } from "@/constants/strings.hr";

const PINEHOOD_URL = "https://pinehood.tech";
const TERMS_URL = "https://cloud.pinehood.tech/terms/";
const PRIVACY_URL = "https://cloud.pinehood.tech/privacy/";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: "auto" }}>
      <Divider />
      <Box
        sx={{
          py: 2,
          px: 3,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Link
          href={PINEHOOD_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          underline="hover"
          sx={{
            color: "text.secondary",
          }}
        >
          {hr.footer.copyright(year)}
        </Link>
        <Link
          href={TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          {hr.footer.terms}
        </Link>
        <Link
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          {hr.footer.privacy}
        </Link>
      </Box>
    </Box>
  );
}
